import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = (typeof window !== 'undefined' && window.location && window.location.origin)
  ? `${window.location.origin}/api`
  : `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fail-closed: default disabled; any error also resolves to disabled. The
// server-side 403 gate is authoritative — this only controls UI affordances.
export function useSignupPolicy() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API_URL}/auth/signup-status`)
      .then((r) => { if (active) setEnabled(Boolean(r.data?.public_signup_enabled)); })
      .catch(() => { if (active) setEnabled(false); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return { enabled, loading };
}

export default useSignupPolicy;
